import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { SourceCreateDialogComponent } from './source-create-dialog.component';
import { SOURCE_CREATE_DIALOG_ID } from './source-create-dialog.model';

@Injectable({ providedIn: 'root' })
export class SourceCreateDialogService extends AbstractDialogService<string, string> {
  constructor() {
    super();
  }

  readonly component = SourceCreateDialogComponent;
  readonly id = SOURCE_CREATE_DIALOG_ID;

  protected override readonly options = {
    cssClass: 'modified-modal ',
  };
}
